<dw-grid-list-page
  [title]="
    !thirdPartyCode() && !articleCode()
      ? ('Doc::Menu:CustomerOpenOrderLines:Open' | abpLocalization)
      : ''
  "
  [activeView]="agGrid.activeView"
  [enableDuplicateBtn]="false"
  [showDuplicateBtn]="false"
  [showDeleteBtn]="false"
  [enableDeleteBtn]="false"
  [showCreationBtn]="false"
  [showExportBtn]="false"
  [hasQuickSearch]="true"
  [toolbarActions]="toolbarActions()"
>
  <dw-grid-ag-grid
    [columnDefs]="columns()"
    [datasource]="datasource"
    (rowClicked)="rowClicked($event)"
    [(selectedRows)]="selectedEntities"
    (selectedRowsClicked)="selectedRowsClicked($event)"
    #agGrid
    [context]="GoliathDocumentEntityNames.CustomerOpenOrderLines.shortname"
  >
  </dw-grid-ag-grid>
</dw-grid-list-page>
